import React, { useState, useContext, useEffect } from "react";
import useFullSchoolList from "../hooks/useFullSchoolList";
import StudentList from "./EmergencyStudentList";
import EnrolledClassesFilter from "./EnrolledClassesFilter";
import useEnrolledClassesDropdown from "../hooks/useEnrolledClasses";
import {
  doc,
  collection,
  setDoc,
  getDocs,
  onSnapshot,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { firestore } from "../shared/FirebaseConfig";
import { UserContext, useUser } from "../shared/UserContext";
import { byLastName } from "../shared/nameSort";
import "./Emergency.css";

const SchoolList = () => {
  const { fullSchoolList } = useFullSchoolList();
  const [selectedClass, setSelectedClass] = useState("");
  const { schoolId } = useContext(UserContext);
  const { user } = useUser();
  const { enrolledClasses } = useEnrolledClassesDropdown();

  useEffect(() => {
    fetchAndHandleLatestStudentData();

    const currentDate = new Date().toISOString().slice(0, 10);
    const emergenciesQuery = collection(
      firestore,
      "schools",
      schoolId,
      "emergencies",
      currentDate,
      "students"
    );

    const unsubscribeFromEmergencies = onSnapshot(
      emergenciesQuery,
      handleSnapshotChanges,
      (error) => {
        console.error("Error with onSnapshot:", error);
      }
    );

    return () => {
      unsubscribeFromEmergencies();
    };
  }, [schoolId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchAndHandleLatestStudentData = async () => {
    try {
      const updatedStudents = await fetchLatestStudentData();
      updateStudentList(updatedStudents);
    } catch (error) {
      console.error("Error fetching and handling latest student data:", error);
    }
  };

  const handleSnapshotChanges = (snapshot) => {
    fetchAndHandleLatestStudentData();
  };

  const fetchLatestStudentData = async () => {
    const schoolRef = doc(firestore, "schools", schoolId);
    const studentsCollectionRef = collection(schoolRef, "students");
    const studentsSnapshot = await getDocs(studentsCollectionRef);


    const updatedStudents = studentsSnapshot.docs.map((doc) => doc.data());
    return updatedStudents;
  };

  const updateStudentList = (_updatedStudents) => {};

  const handleStudentClick = (_studentId) => {};

  const handleSelectClass = (selectedClass) => {
    setSelectedClass(selectedClass);
  };

  const handleClickDelete = async (studentId) => {
    try {
      const currentDate = new Date().toISOString().slice(0, 10);
      const emergencyDocRef = doc(
        firestore,
        "schools",
        schoolId,
        "emergencies",
        currentDate,
        "students",
        studentId
      );

      await deleteDoc(emergencyDocRef);


      // No need to wait, as it's an asynchronous operation
      fetchAndHandleLatestStudentData();
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  const markEmergency = async (studentId) => {
    try {
      const schoolRef = doc(firestore, "schools", schoolId);
      const emergencyCollectionRef = collection(schoolRef, "emergencies");

      const currentDate = new Date().toISOString().slice(0, 10);
      const emergencyDocRef = doc(emergencyCollectionRef, currentDate);

      const currentTimestamp = serverTimestamp();
      const emergencyData = {
        timestamp: currentTimestamp,
        sid: studentId,
        clickedBy: user.displayName || "Unknown User",
      };

      const studentEmergencyCollectionRef = collection(
        emergencyDocRef,
        "students"
      );

      await setDoc(
        doc(studentEmergencyCollectionRef, studentId),
        emergencyData
      );


    } catch (error) {
      console.error("Error marking emergency:", error);
    }
  };

  const filteredStudents = fullSchoolList.filter((student) => {
    if (selectedClass === "") {
      return enrolledClasses.some((enrolledClass) =>
        student.enrolledClasses.includes(enrolledClass.classId)
      );
    } else {
      return student.enrolledClasses.includes(selectedClass);
    }
  });

  // Sort the filteredStudents array by last name (compound surnames included).
  const sortedStudents = filteredStudents.slice().sort(byLastName);

  return (
    <div>
      <h2>Full School List</h2>
      <EnrolledClassesFilter
        className="class-select"
        style={{ width: "200px", fontSize: "18px", margin: "20px" }}
        onSelectClass={handleSelectClass}
      />
      <StudentList
        key={selectedClass}
        students={sortedStudents}
        onStudentClick={handleStudentClick}
        markEmergency={markEmergency}
        handleClickDelete={handleClickDelete}
      />
    </div>
  );
};

export default SchoolList;
